import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useMemo } from 'react';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import dayjs from 'dayjs';
import { COLORS, FONTS } from '../../../constants';
import { IFacilities } from '../../../types/sports.types';

interface HeaderCourtsProps {
  facility?: IFacilities;
}

const HeaderCourts: FC<HeaderCourtsProps> = ({ facility }) => {
  const isDesktop = useIsDesktop();

  const styles = StyleSheet.create({
    greenText: {
      fontSize: isDesktop() ? 14 : 12,
      fontFamily: FONTS.AvenirMedium,
      color: COLORS.GREEN,
      fontWeight: '500',
      lineHeight: 20,
      textTransform: 'uppercase',
    },
    greyText: {
      fontSize: isDesktop() ? 14 : 12,
      fontFamily: FONTS.AvenirMedium,
      color: COLORS.DARKER_GREY,
      fontWeight: '500',
      lineHeight: 20,
      letterSpacing: 1,
      textTransform: 'uppercase',
    },
  });

  const renderWeather = useMemo(() => {
    const dates: Date[] = [];
    const today = new Date();

    for (let i = 0; i < 4; i++) {
      const date = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + i
      );
      dates.push(date);
    }
    return dates.map((date, index) => (
      <View
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          marginRight: 20,
        }}
        key={date.toString()}
      >
        <Image
          source={
            index % 2 === 0
              ? require('../../../assets/sunny-icon.png')
              : require('../../../assets/weather.png')
          }
          style={{
            width: 24,
            height: 24,
            marginBottom: 5,
            tintColor: STYLE_VARS.primaryColor,
          }}
        />
        <Text style={styles.greyText}>{dayjs(date).format('ddd DD MMM')}</Text>
      </View>
    ));
  }, [styles]);
  if (isDesktop()) {
    return (
      <View style={{ flexDirection: 'row' }}>
        <Image
          source={{
            uri: facility?.image,
          }}
          style={{
            width: 300,
            height: 200,
            resizeMode: 'cover',
          }}
        />
        <View
          style={{
            flexDirection: 'column',
            marginLeft: 10,
            justifyContent: 'space-between',
          }}
        >
          <View style={{ gap: 5 }}>
            <Text style={styles.greenText}>Opening Hours</Text>
            <Text style={styles.greyText}>{facility?.opening_hours}</Text>
          </View>
        </View>
      </View>
    );
  }
  return (
    <>
      <View>
        <Image
          source={{
            uri: facility?.image,
          }}
          style={{
            width: '100%',
            height: 230,
            resizeMode: 'cover',
          }}
        />
      </View>
      <View
        style={{ paddingHorizontal: 20, paddingBottom: 10, paddingTop: 20 }}
      >
        <Text
          style={[
            styles.greyText,
            {
              textAlign: 'center',
            },
          ]}
        >
          {facility?.description
            ? facility.description
            : 'To make a booking, select the date and available timeslot on the court you wish to book'}
        </Text>
      </View>
    </>
  );
};

export default HeaderCourts;
